export function calculateColorFilterColor(value, type, colorValues) {
  if (type === 'rl') {
    if (value <= parseInt(colorValues.oneRl, 10)) {
      return colorValues.oneRlColor;
    } else if (value <= parseInt(colorValues.twoRl, 10)) {
      return colorValues.twoRlColor;
    } else if (value <= parseInt(colorValues.threeRl, 10)) {
      return colorValues.threeRlColor;
    } else if (value > parseInt(colorValues.threeRl, 10)) {
      return colorValues.fourRlColor;
    }
  } else if (type === 'qd') {
    if (value <= parseInt(colorValues.oneQd, 10)) {
      return colorValues.oneQdColor;
    } else if (value <= parseInt(colorValues.twoQd, 10)) {
      return colorValues.twoQdColor;
    } else if (value <= parseInt(colorValues.threeQd, 10)) {
      return colorValues.threeQdColor;
    } else if (value > parseInt(colorValues.threeQd, 10)) {
      return colorValues.fourQdColor;
    }
  }

  return 'transparent';
}



// WEBPACK FOOTER //
// ./src/services/calculateColorFilterColor.js